import { urlEncodeB64 } from "./urlEncodeB64";

export function generateState(connectionName: string, redirectUrl: string): string {
    const state = {
        connection_name: connectionName,
        redirect_url: redirectUrl
    };
    return urlEncodeB64(btoa(JSON.stringify(state)));
}
